import { Outlet } from 'react-router-dom'
import FacilitiesList from 'components/FacilitiesList'

type MyFacilitiesProps = {
  view: string
  user: any
}

const MyFacilities = ({ view, user }: MyFacilitiesProps) => {
  return (
    <>
      <FacilitiesList view={view} user={user} />
      <Outlet />
    </>
  )
}

export default MyFacilities
